/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListAnnouncement } from '../models/api-response-list-announcement';
import { ApiResponseListAnnouncementInboxItem } from '../models/api-response-list-announcement-inbox-item';
import { ApiResponseVoid } from '../models/api-response-void';
import { bootstrap } from '../fn/announcement-client-api/bootstrap';
import { Bootstrap$Params } from '../fn/announcement-client-api/bootstrap';
import { inbox } from '../fn/announcement-client-api/inbox';
import { Inbox$Params } from '../fn/announcement-client-api/inbox';
import { markSeen } from '../fn/announcement-client-api/mark-seen';
import { MarkSeen$Params } from '../fn/announcement-client-api/mark-seen';

@Injectable({ providedIn: 'root' })
export class AnnouncementClientApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `markSeen()` */
  static readonly MarkSeenPath = '/v1/api/announcement-client/{slug}/seen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markSeen()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  markSeen$Response(params: MarkSeen$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return markSeen(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markSeen$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  markSeen(params: MarkSeen$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.markSeen$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `inbox()` */
  static readonly InboxPath = '/v1/api/announcement-client/inbox';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inbox()` instead.
   *
   * This method doesn't expect any request body.
   */
  inbox$Response(params?: Inbox$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAnnouncementInboxItem>> {
    return inbox(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inbox$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inbox(params?: Inbox$Params, context?: HttpContext): Observable<ApiResponseListAnnouncementInboxItem> {
    return this.inbox$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAnnouncementInboxItem>): ApiResponseListAnnouncementInboxItem => r.body)
    );
  }

  /** Path part for operation `bootstrap()` */
  static readonly BootstrapPath = '/v1/api/announcement-client/bootstrap';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `bootstrap()` instead.
   *
   * This method doesn't expect any request body.
   */
  bootstrap$Response(params?: Bootstrap$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAnnouncement>> {
    return bootstrap(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `bootstrap$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  bootstrap(params?: Bootstrap$Params, context?: HttpContext): Observable<ApiResponseListAnnouncement> {
    return this.bootstrap$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAnnouncement>): ApiResponseListAnnouncement => r.body)
    );
  }

}
